import { render, staticRenderFns } from "./ShareFolder.vue?vue&type=template&id=6fe67f3e&"
import script from "./ShareFolder.vue?vue&type=script&lang=js&"
export * from "./ShareFolder.vue?vue&type=script&lang=js&"
import style0 from "./ShareFolder.vue?vue&type=style&index=0&id=6fe67f3e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports